import ErrorNoti from 'components/common/ErrorNoti';
import Loading from 'components/common/Loading';
import Pagination from 'components/common/Pagination';
import useDashboardTable from 'hooks/dashboard/useDashboardTable';
import styled from 'styled-components';

const DashboardTableRow = ({ register, idx }) => {
  const { company, name, createdAt } = register;
  const date = createdAt.split(' ')[0];

  return (
    <DashboardTableRowBlock>
      <div className="table-col-small">{idx + 1}</div>
      <div className="table-col">{company ? company : 'company'}</div>
      <div className="table-col">{name}</div>
      <div className="table-col">{date}</div>
    </DashboardTableRowBlock>
  );
};

const DashboardTableRowBlock = styled.div`
  height: 40px;
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  &:last-child {
    margin-bottom: 20px;
  }
`;

const DashboardTable = ({ place }) => {
  const {
    isLoading,
    error,
    totalPage,
    registerList,
    currentPage,
    setCurrentPage,
  } = useDashboardTable(place ? 'space' : 'device');

  if (
    isLoading ||
    error?.response.status === 401 ||
    error?.response.data.error === 'AuthorizationNotFound'
  )
    return <Loading style={{ marginTop: 100 }} />;
  if (error?.response.status === 500)
    return <ErrorNoti style={{ marginTop: 80 }} />;

  return (
    <DashboardTableBlock>
      <div className="subtitle">
        {place ? '장소 등록 대기' : '장비 등록 대기'}
      </div>
      <div className="table">
        <div className="table-header">
          <div className="table-col-small">번호</div>
          <div className="table-col">소속</div>
          <div className="table-col">설치 장소</div>
          <div className="table-col">등록일</div>
        </div>
        {registerList?.length === 0 ? (
          <div className="no-list">목록이 없습니다</div>
        ) : (
          <>
            {registerList?.map((register, idx) => (
              <DashboardTableRow
                key={idx}
                register={register}
                idx={idx + (currentPage - 1) * 10}
              />
            ))}
            <Pagination
              totalPage={totalPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </>
        )}
      </div>
    </DashboardTableBlock>
  );
};

export default DashboardTable;

const DashboardTableBlock = styled.div`
  .table {
    margin-top: 1rem;
    margin-bottom: 2rem;
    padding: 0 30px;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.1);
    font-size: 14px;
  }

  .table-header {
    height: 40px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    font-weight: bold;
  }

  .table-col {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .table-col-small {
    width: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .no-list {
    padding: 2rem;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
  }
`;
